
import React, { useEffect, useState } from "react";
import displayINRCurrency from "../helpers/displayCurrency";

const AdminOrders = () => {

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    const res = await fetch(
      "https://lappyshop.onrender.com/api/all-orders",
      { credentials: "include" }
    );

    const data = await res.json();

    if (data.success) {
      setOrders(data.data);
    }
  };

  const updateStatus = async (orderId, status) => {

    await fetch(
      "https://lappyshop.onrender.com/api/update-order-status",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          orderId,
          status
        })
      }
    );

    fetchOrders();
  };

  const statusColor = (status) => {

    switch (status) {

      case "processing":
        return "bg-yellow-100 text-yellow-700";

      case "shipped":
        return "bg-blue-100 text-blue-700";

      case "out_for_delivery":
        return "bg-purple-100 text-purple-700";

      case "delivered":
        return "bg-green-100 text-green-700";

      case "cancelled":
        return "bg-red-100 text-red-700";

      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen py-8">

      <div className="container mx-auto px-4">

        <h1 className="text-3xl font-semibold mb-6">
          Admin Orders
        </h1>

        {orders.length === 0 && (
          <div className="bg-white p-6 text-center rounded shadow">
            No orders found
          </div>
        )}

        <div className="space-y-6">

          {orders.map((order) => (

            <div
              key={order._id}
              className="bg-white rounded shadow p-6"
            >

              {/* Header */}

              <div className="flex justify-between items-center mb-4">

                <div>

                  <p className="text-sm text-gray-500">
                    Order ID
                  </p>

                  <p className="font-semibold">
                    {order._id}
                  </p>

                  <p className="mt-2 font-medium">
                    {order.userId?.name}
                  </p>

                  <p className="text-sm text-gray-500">
                    {order.userId?.email}
                  </p>

                </div>

                <div className="flex items-center gap-3">

                  <span
                    className={`px-3 py-1 rounded-full text-sm ${statusColor(order.orderStatus)}`}
                  >
                    {order.orderStatus}
                  </span>

                  <select
                    value={order.orderStatus}
                    onChange={(e) =>
                      updateStatus(order._id, e.target.value)
                    }
                    className="border px-2 py-1 rounded"
                  >

                    <option value="processing">
                      Processing
                    </option>

                    <option value="shipped">
                      Shipped
                    </option>

                    <option value="out_for_delivery">
                      Out for Delivery
                    </option>

                    <option value="delivered">
                      Delivered
                    </option>

                    <option value="cancelled">
                      Cancel Order
                    </option>

                  </select>

                </div>

              </div>

              {/* Products */}

              {order.items.map((item) => (

                <div
                  key={item._id}
                  className="flex justify-between border-t py-3"
                >

                  <span>

                    {item.productId?.productName}

                    <span className="text-gray-500 ml-2">
                      × {item.quantity}
                    </span>

                  </span>

                  <span className="font-semibold text-red-600">

                    {displayINRCurrency(
                      item.price * item.quantity
                    )}

                  </span>

                </div>

              ))}

              {/* Total */}

              <div className="border-t pt-4 mt-2 flex justify-between font-semibold text-lg">

                <span>Total</span>

                <span>

                  {displayINRCurrency(order.totalAmount)}

                </span>

              </div>

            </div>

          ))}

        </div>

      </div>

    </div>
  );
};

export default AdminOrders;